import { Applicant } from '../applicant';


export class ApplicantSerializer {
    fromJson(json: any): Applicant {
   const data = new Applicant();
        data.id = json.id;
        data.name =json.lastName? json.firstName + ' ' + json.lastName : json.firstName;
        data.firstName =json.firstName;
        data.lastName=json.lastName;
        data.email=json.email;
        data.phone=json.phone;
        data.summary= json.summary;
        data.currentCtc=json.currentCtc;
        data.currentTitle= json.currentTitle;
        data.fullName=json.lastName? json.firstName + ' ' + json.lastName : json.firstName;
        data.resumeUrl = json.resumeUrl;
        data.resumeFileName = json.resumeFileName;
        data.bonus = json.bonus;
        data.alternatePhone=json.alternatePhone;
        data.alreadyInProcess=json.alreadyInProcess;
        data.remarks=json.remarks;
        data.sourceId= json.sourceId;
        data.referredById=json.referredById;
        data.source=json.source;
        data.referredBy=json.referredBy;
        data.sourceType=json.sourceType;
        return data;
    }

    toJson(data: Applicant): any {
        return {
            id: data.id,
            //applicant :data.applicant,
            firstName: data.firstName,
            lastName :data.lastName,
            email:data.email,
            phone :data.phone,
            summary: data.summary,
            currentCtc:data.currentCtc,
            currentTitle:data.currentTitle,
            bonus:data.bonus,
            alternatePhone :data.alternatePhone,
            remarks : data.remarks,
            sourceId :data.sourceId,
            referredById :data.referredById
        };
    }
}